function toTelHref(number) {
    const digits = String(number).replace(/\D/g, "");
    return digits ? `tel:${digits}` : undefined;
}

function phoneEntries(contact) {
    if (Array.isArray(contact.phones) && contact.phones.length > 0) {
        return contact.phones.map((p) =>
            typeof p === "string"
                ? { label: null, number: p }
                : { label: p.label || null, number: p.number }
        );
    }
    if (contact.phone) {
        return [{ label: null, number: contact.phone }];
    }
    return [];
}

function ContactsList({ contacts, variant = "light" }) {
    if (!Array.isArray(contacts) || contacts.length === 0) return null;

    const isDark = variant === "dark";
    const emailClass = isDark ? "text-blue-light" : "text-blue-dark underline";

    return (
        <ul className={isDark ? "list-none space-y-5" : "mb-4 list-disc pl-6 space-y-3"}>
            {contacts.map((contact, i) => (
                <li key={i} className={isDark ? "" : "mb-1"}>
                    <div className={isDark ? "" : "font-semibold"}>{contact.name}</div>
                    {contact.role && <p>{contact.role}</p>}
                    {phoneEntries(contact).map((phone, j) => {
                        const href = toTelHref(phone.number);
                        const text = phone.label
                            ? `${phone.label} ${phone.number}`
                            : phone.number.startsWith("Tel")
                              ? phone.number
                              : `Tel. ${phone.number}`;
                        return href ? (
                            <div key={j}>
                                <a href={href}>{text}</a>
                            </div>
                        ) : (
                            <div key={j}>{text}</div>
                        );
                    })}
                    {contact.email && (
                        <div className={emailClass}>
                            <a href={`mailto:${contact.email}`}>{contact.email}</a>
                        </div>
                    )}
                </li>
            ))}
        </ul>
    );
}

export default ContactsList;
export { phoneEntries, toTelHref };
